import type { CandidateDto } from '../candidate.dto';
import { qualifiesForRobinVerified } from '../robin-verified-qualification';

export type Verified = {
  isVerified: boolean;
  robinVerifiedQualified: boolean;
  verifiedAt?: string;
  jobs?: string;
  salary?: string;
  travelTime?: string;
  workingHoursPerWeek?: string;
  availableDays?: string;
  shifts?: string;
  savePreferences?: string;
  verifiedBy?: string;
  readyForJobOffers?: string;
  certificatesAndLicenses?: string;
};

export const toVerified = (dto: CandidateDto): Verified => {
  const verifiedAtIso = dto._source.robin_verified_metadata?.verified_at;

  return {
    isVerified: dto._source.robin_verified_metadata ? true : false,
    robinVerifiedQualified: qualifiesForRobinVerified({
      robinVerified: dto._source.robin_verified,
      verifiedAtIso,
    }),
    verifiedAt: verifiedAtIso,
    jobs: dto._source.robin_verified_metadata?.jobs,
    salary: dto._source.robin_verified_metadata?.salary,
    travelTime: dto._source.robin_verified_metadata?.travel_time,
    workingHoursPerWeek: dto._source.robin_verified_metadata?.working_hours_per_week,
    availableDays: dto._source.robin_verified_metadata?.available_days,
    shifts: dto._source.robin_verified_metadata?.shifts,
    savePreferences: dto._source.robin_verified_metadata?.save_preferences,
    verifiedBy: undefined,
    readyForJobOffers: undefined,
    certificatesAndLicenses: undefined,
  };
};
